import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    boxSizing: 'border-box',
    cursor: 'pointer',
    backgroundColor: ({ selected }) => (selected ? '#F8D8FF' : 'white'),

    '&:not(:last-child)': {
      borderBottom: '1px solid lightgrey'
    },

    '&:last-child': {
      marginBottom: ({ mobile }) => (mobile ? '0' : '30px')
    }
  },

  taken: {
    minHeight: '114px',
    height: '114px',
    maxHeight: '114px'
  },

  waiting: {
    maxHeight: 162
  }
}))

export default useStyles
